import moment from "moment";
import i18n from "src/i18n";
import { VirtualAccount } from "./types";

// 가상계좌 만료일 확인 및 포맷팅
const checkExpireText = (virtualAccount: VirtualAccount): string => {
  if (!virtualAccount) return "";

  const today = moment();
  const limit = `${virtualAccount.expireDate} ${virtualAccount.expireTime}`;
  const limitDate = moment(limit, "YYYYMMDD HHmm");

  if (moment(today).isSameOrAfter(limitDate)) {
    return "만료";
  }

  return moment(limit, "YYYYMMDD HHmm").format("YYYY-MM-DD HH:mm");
};

// 진행 상태에 따른 상태 텍스트 반환
const checkProgressStatus = (progressStatus: string) => {
  let status = i18n.t("detail.cashReceiptStatus.pending", { ns: "contract" });
  if (progressStatus === "TEMP_SAVE") {
    status = i18n.t("detail.cashReceiptStatus.draft", { ns: "contract" });
  }
  if (progressStatus === "ISSUE_COMPLETE") {
    status = i18n.t("detail.cashReceiptStatus.issued", { ns: "contract" });
  }
  if (progressStatus === "ISSUE_REVOKE") {
    status = i18n.t("detail.cashReceiptStatus.issuanceCancelled", { ns: "contract" });
  }
  if (progressStatus === "TRANS_BEFORE") {
    status = i18n.t("detail.cashReceiptStatus.notSent", { ns: "contract" });
  }
  if (progressStatus === "TRANS_READY") {
    status = i18n.t("detail.cashReceiptStatus.transmissionPending", { ns: "contract" });
  }
  if (progressStatus === "TRANS_ONGOING") {
    status = i18n.t("detail.cashReceiptStatus.transmitting", { ns: "contract" });
  }
  if (progressStatus === "TRANS_SUCCESS") {
    status = i18n.t("detail.cashReceiptStatus.transmissionSuccessful", { ns: "contract" });
  }
  if (progressStatus === "TRANS_FAIL") {
    status = i18n.t("detail.cashReceiptStatus.transmissionFailed", { ns: "contract" });
  }
  if (progressStatus === "ISSUE_MANUAL") {
    status = i18n.t("detail.cashReceiptStatus.manuallyIssued", { ns: "contract" });
  }
  return status;
};

export { checkExpireText, checkProgressStatus };
